import type { ReactNode } from "react";
import { Panel } from "@/components/ui/panel";
import { PageHeader } from "@/components/shared/page-header";
import { cn } from "@/lib/utils";
import { observer } from "mobx-react";

interface SettingsPageShellProps {
  title: string;
  description: string;
  actions?: ReactNode;
  /** Rendered inside the header Panel, full width BELOW the title/description
   *  — for a control that belongs to the section as a whole rather than to the
   *  content below it (NG-837: the member-teams picker). `actions` is the
   *  right slot for something that sits beside the title; this is for one that
   *  the description reads as an instruction for. */
  headerControl?: ReactNode;
  /** Workspace settings pages pad here (not on the layout shell) so full-bleed
   *  table tabs can span edge to edge; team/project settings layouts pad
   *  themselves and pass false. */
  padded?: boolean;
  children?: ReactNode;
}

export const SettingsPageShell = observer(function SettingsPageShell({
  title,
  description,
  actions,
  headerControl,
  padded = true,
  children,
}: SettingsPageShellProps) {
  return (
    <div className={cn("space-y-6", padded && "px-8")}>
      <Panel>
        {headerControl ? (
          <div className="flex flex-col gap-3">
            <PageHeader title={title} description={description} actions={actions} />
            {headerControl}
          </div>
        ) : (
          <PageHeader title={title} description={description} actions={actions} />
        )}
      </Panel>
      {children}
    </div>
  );
});
